module.exports = __webpack_public_path__ + "static/media/more-filled.d3fa657d.svg";